import { render, staticRenderFns } from "./AggiungiProva.vue?vue&type=template&id=4fcfe341&"
import script from "./AggiungiProva.vue?vue&type=script&lang=js&"
export * from "./AggiungiProva.vue?vue&type=script&lang=js&"
import style0 from "./AggiungiProva.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports